import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { Company } from '../../types/company';
import { Proxy } from '../../types/proxy';
import {CompanyType} from "../../types/company-type";
import {Shareholder} from "../../types/shareholder";

type Partner = {
  label : string,
  boardMember: boolean,
  physical: boolean,
  name ?: string,
  krs ?: string,
  nip ?: string,
  pesel ?: string,
  idType ?: string,
  idValue ?: string,
  krkId ?: number
}

@Component({
  selector: 'summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

  @Input() company !: Company;
  @Input() companyType !: CompanyType;
  @Input() isAssignee !: boolean;
  @Input() noPesel !: boolean;
  @Input() onlyPesels !: boolean;
  @Input() proxy !: Proxy;
  @Input() authFileName ?: string;
  @Input() authPaymentFileName ?: string;
  @Input() krkFileName ?: string;
  @Input() paymentFileName ?: string;
  @Input() registerFileName ?: string;
  
  @Input() dataAgree !: boolean;
  @Output() dataAgreeChange = new EventEmitter<boolean>();
  @Input() conditionsAgree !: boolean;
  @Output() conditionsAgreeChange = new EventEmitter<boolean>();
  @Input() rodoAgree !: boolean;
  @Output() rodoAgreeChange = new EventEmitter<boolean>();
  
  identityTypesMap : Map<string, string> = new Map([["PASZPORT","Paszport"], ["DOWOD","Dowód"], ["INNY_DOK","Inny dokument"]]);
  CompanyType = CompanyType;
  partners: Partner[] = [];
  summaryFormDirty: boolean = false;
  rodoVisible : boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.summaryFormDirty = false;
    this.rodoVisible = false;
  }

  setFormDirty(dirty: boolean) : void {
    this.summaryFormDirty = dirty;
  }

  editFormInvalid() : boolean {
    if (this.summaryFormDirty && this.formInvalid()) {
      return true;
    }
    return false;
  }

  formInvalid() : boolean {
    return !this.dataAgree || !this.conditionsAgree || !this.rodoAgree;
  }

  showRodo() {
    this.rodoVisible = true;
  }

  refreshPartners() {
    // update listy wspólników
    this.partners = [];
    if (this.company?.shareholders) {
      let i = 1;
      for (let shareholder of this.company.shareholders) {
        this.shareholdersToPartners(shareholder, i.toString());
        ++i;
      }
    }
  }

  shareholdersToPartners(shareholder: Shareholder, label: string) {
    this.partners.push(
      {
        label: label,
        boardMember: shareholder.boardMember,
        physical: shareholder.type == 'OF_P_1',
        name: shareholder.personalData ? shareholder.personalData.firstname + " " + shareholder.personalData.surname : shareholder.name,
        krs: shareholder.krs,
        nip: shareholder.nip,
        pesel: shareholder.personalData?.pesel,
        idType: shareholder.personalData?.identityType,
        idValue: shareholder.personalData?.identityValue,
        krkId: shareholder.personalData?.krkId
      });
    if (shareholder.shareholders && shareholder.shareholders.length > 0) {
      let i:number = 1;
      for (let sh of shareholder.shareholders) {
        this.shareholdersToPartners(sh, label + "." + i);
        ++i;
      }
    }
  }
}
